import React, { useEffect, useState } from "react";
import { Module } from "../types/Module";
import { Form, Button, Row, Col } from "react-bootstrap";
import { StoreState } from "../redux/reducers";
import { useSelector } from "react-redux";
import "../styles/Form.css";

interface Props {
  onSave: (module: Module) => void;
  initialData?: Module | null;
  clearAfterSubmit: () => void;
}

const initialState: Module = {
  id: 0,
  projectId: 0,
  name: "",
};

const ModuleForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [form, setForm] = useState<Module>(initialState);
  const projects = useSelector((state: StoreState) => state.project);

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        projectId: Number(initialData.projectId),
      });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "projectId" ? parseInt(value) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(form);
    setForm(initialState);
    clearAfterSubmit();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="projectId">
            <Form.Label>Project</Form.Label>
            <Form.Select
              name="projectId"
              value={form.projectId ? form.projectId.toString() : ""}
              onChange={handleChange}
              style={{
                borderColor: "rgb(215, 210, 210)",
              }}
              required
            >
              <option value="">Select a project</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="name">
            <Form.Label>Module Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={12}>
          <div className="form-buttons">
            <Button type="submit" className="btn-save">
              {initialData ? "Update" : "Add"} Module
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default ModuleForm;
